const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async signUp({ rootState }, params = {}) {
      const data = await rootState.http("/examination/signUp", params);
      return data;
    },
    async queryLearnClassList({ rootState }, params = {}) {
      const data = await rootState.http("/learnContentClass/queryLearnClassList", params);
      return data;
    },
    async getLearnContentTextDetail({ rootState }, params = {}) {
      const data = await rootState.http("/learn/content/getLearnContentTextDetail", params);
      return data;
    },
    async searchLearnContentSettingPage({ rootState }, params = {}) {
      const data = await rootState.http("/learn/content/searchLearnContentSettingPage ", params);
      return data;
    },
    async likeContent({ rootState }, params = {}) {
      const data = await rootState.http("/content/likeContent", params);
      return data;
    },
    async queryContentDetail({ rootState }, params = {}) {
      const data = await rootState.http("/content/queryContentDetail", params);
      return data;
    },
    async queryContentClassPage({ rootState }, params = {}) {
      const data = await rootState.http("/content/queryContentClassPage", params);
      return data;
    },
    async queryContentPage({ rootState }, params = {}) {
      const data = await rootState.http("/content/queryContentPage", params);
      return data;
    },
    // 互动分类
    // 查询 分类列表
    async queryInvitationClassList({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitationClass/queryInvitationClassList", params);
      return data;
    },
    // 创建 互动分类
    async createInvitationClass({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitationClass/createInvitationClass", params);
      return data;
    },
    // 删除 互动分类
    async deleteInvitationClass({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitationClass/deleteInvitationClass", params);
      return data;
    },
    // 排序 互动分类
    async changeInvitationClassSort({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitationClass/changeInvitationClassSort", params);
      return data;
    },
    // 学习互动
    // 帖子列表
    async searchLearnInvitationPage({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/searchLearnInvitationPage", params);
      return data;
    },
    // 帖子明细 详情
    async getLearnInvitationDetail({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/getLearnInvitationDetail", params);
      return data;
    },
    // 帖子评论列表
    async searchInvitationCommentPage({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/searchInvitationCommentPage", params);
      return data;
    },
    // 点赞帖子
    async thumbsUpLearnInvitation({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/thumbsUpLearnInvitation", params);
      return data;
    },
    // 我的帖子列表
    async myLearnInvitationPage({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/myLearnInvitationPage", params);
      return data;
    },
    // 我的评论列表
    async myInvitationCommentPage({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/myInvitationCommentPage", params);
      return data;
    },
    // 新建帖子
    async createLearnInvitation({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/createLearnInvitation", params);
      return data;
    },
    // 新建评论
    async createInvitationComment({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/createInvitationComment", params);
      return data;
    },
    // 删除帖子
    async deleteLearnInvitation({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/deleteLearnInvitation", params);
      return data;
    },
    // 删除评论
    async deleteInvitationComment({ rootState }, params = {}) {
      const data = await rootState.http("/learn/invitation/deleteInvitationComment", params);
      return data;
    }
  }
};

export default store;
